import * as types from "./action-types";
import * as fb from "../../firebase/firebasejs";
import { store } from "../configureStore";
import { fecha } from "../../services/utils";
import { showSnackbar } from "./organizers-actions";
import {
  calculateAthlete,
  calculatePositions,
} from "../../components/pages/AuthorizedUsers/Timing/TimingLogic/TimingUtils.jsx";

export function initEvents() {
  var ref = fb.db.ref(fb.EventosLista);
  return (dispatch) => {
    ref
      .orderByChild("iDEvento")
      .startAt(0)
      .on("value", (snapshot) => {
        dispatch({
          type: types.INIT_EVENTS,
          events: snapshot.val(),
        });
      });
  };
}
//#################################################################
export function createPublicEvent(data, userID, atleteAccount) {
  var ref = fb.db.ref(fb.EventosLista);

  const defaultObject = {
    detalleEvento: {
      ciudadEvento: data.ciudadEvento || "",
      convocatoria: false,
      cronometrajeDisponible: false,
      descripcionEvento: data.descripcionEvento || "",
      eventoDisponible: data.eventoDisponible || 0,
      fechaEvento: data.fechaEvento || "2021-12-31",
      horaEvento: data.horaEvento || "05:00:00",
      iDEvento: 0,
      imagenEvento: "",
      logoEvento:
        data.logoEvento ||
        "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/FotosFondo%2FfotoPrincipal_Dashport_bajaResolucion.jpg?alt=media&token=6042c273-cbab-4cf3-bba3-83a350f8ff4d",
      lugarEvento: data.lugarEvento || "",
      nombreEvento: data.nombreEvento || "",
      nombreEventoCorto: data.nombreEvento || "",
      organizador: {
        colorOrganizador: data.colorOrganizador || "#000000",
        linkAvisoPrivacidad: "https://dashport.run/politicas-privacidad/",
        linkEvento: "",
        logoOrganizador:
          data.logoOrganizador ||
          "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/logosDashport%2FDASHPORT_white_horizontal.png?alt=media&token=e9e08a40-56ae-4297-bffc-5522bcc9687a",
        nombreOrganizador: "Dashport",
        telefonoContacto: 9997405097,
        webOrganizador: "https://dashport.run/",
      },
      paisEvento: data.paisEvento || "",
      tipoDeEvento: "Carrera",
      userCreate: userID,
    },
    configuracion: {
      cronometrajeDisponible: true,
      eventoPublico: true,
      fotografiasDisponibles: true,
      inscripcionesDisponibles: true,
      resultadosDisponibles: true,
      tiempoRealDisponible: true,
    },
    inscripcionesConfiguracion: {
      configuracion: {
        categoriasInferiores: false,
        codigoQR: true,
        deslindeImpreso: true,
        deslindeInMail: false,
        edadActual: true,
        entregaKits: {
          available: false,
          items: {
            item_1: {
              code: "item_1",
              description: "entrega de kit",
              itemForm: [
                {
                  anchoCampo: "s12 m12 l12",
                  campo: 10,
                  etiqueta: "Documento mostrado",
                  iDCampo: "documento",
                  longitud: 100,
                  observacion: "",
                  tipoCampo: "text",
                  validacion: "",
                  valor: "",
                },
              ],
              itemOrder: "insc",
              name: "Entrega del kit completo",
            },
          },
        },
        formasDePago: {
          codigoInscripcion: false,
          comisionGlobal: atleteAccount.comision || 0.07,
          conektaCard: {
            comision: atleteAccount.comision || 0.07,
            disponible: true,
            montoMaximo: 3000,
            tipoComision: 1,
          },
          conektaOxxoPay: {
            comision: atleteAccount.comision || 0.07,
            disponible: true,
            tipoComision: 1,
          },
        },
        rutaDetalleInscrito: "https://dashport.run/detalle-inscrito",
        separarApellidos: false,
      },
      gruposFormularios: {
        general: [
          {
            campo: 1,
            etiqueta: "Campo de prueba",
            iDCampo: "pordefecto",
            longitud: 100,
            observacion: "",
            tipoCampo: "text",
            validacion: "Requerido",
            valor: "",
          },
        ],
      },
      formulario: [
        {
          campo: 1,
          etiqueta: "Campo de prueba",
          iDCampo: "pordefecto",
          longitud: 100,
          observacion: "",
          tipoCampo: "text",
          validacion: "Requerido",
          valor: "",
        },
      ],
      iDEvento: 200,
    },
    oganizadoresEvento: {
      [userID]: {
        accesoPermitido: true,
        correo: atleteAccount.correo,
        nombre: atleteAccount.nombres + " " + atleteAccount.apellidos,
        perfil: "MasterOrganizador",
      },
      RHlMQSMvpPTBySpb1m32F196xnk1: {
        accesoPermitido: true,
        correo: "eduardomadrid84@yahoo.com",
        nombre: "Eduardo Madrid Alvarez de Lugo",
        perfil: "master",
      },
      McqSKr5W0nPVfvbyJuKNcWvKpHK2: {
        accesoPermitido: true,
        correo: "info@dashport.run",
        nombre: "Info Dashport",
        perfil: "master",
      },
    },
    puntosDeControl: {
      kPC_0: {
        descripcionFinalPunto: "Meta del evento",
        flotante: false,
        kNroPunto: 0,
        lat: 1,
        lng: 1,
        modalidadesPuntoDeControl: {},
      },
    },
    autorizacionOrganizador: {
      "-MNOp1uPLwY0praJPjmv": {
        correo: atleteAccount.correo,
        fechaAutoriza: "2020/11/30 09:45:04",
        perfil: "MasterOrganizador",
        status: "ok",
        userIdAuth: userID,
      },
      "-MNOp1uPLwY0praJPjmv1": {
        correo: "eduardomadrid84@yahoo.com",
        fechaAutoriza: "2020/11/30 09:45:04",
        perfil: "master",
        status: "ok",
        userIdAuth: userID,
      },
      "-MNOp1uPLwY0praJPjmv2": {
        correo: "info@dashport.run",
        fechaAutoriza: "2020/11/30 09:45:04",
        perfil: "master",
        status: "ok",
        userIdAuth: userID,
      },
    },
    modalidades: {
      modalidad_1: {
        codigoModalidad: 1,
        descripcionModalidad: "Modalidad DEMO",
        hSalidas: {
          serie_1: {
            descripcionSerie: "Salida Modalidad 1",
            hS: "0000-00-00 00:00:00",
            hsTimeStamp: 0,
            serie: 1,
          },
        },
        modalidad: 10,
        ramaCat: {
          rama_F: {
            categorias: {
              categoria_1: {
                absolutos: false,
                cantidadGanadores: 3,
                capacidad: 200,
                codigo: 1,
                edadDesde: 18,
                edadHasta: 29,
                inscritos: 0,
                serie: 1,
                minimoParticipantes: 10,
                nombreCategoria: "Libre",
                precioKey: "precio_1",
              },
            },
            rama: "F",
          },
          rama_V: {
            categorias: {
              categoria_1: {
                absolutos: false,
                cantidadGanadores: 3,
                capacidad: 200,
                codigo: 1,
                edadDesde: 18,
                edadHasta: 29,
                inscritos: 0,
                serie: 1,
                minimoParticipantes: 10,
                nombreCategoria: "Libre",
                precioKey: "precio_1",
              },
            },
            rama: "V",
          },
        },
      },
    },
    modalidadesInscripcion: {
      modalidad_1: {
        codigoModalidad: 1,
        configModalidad: {
          camposAdicionalesModalidad: {},
          folios: {
            capacidad: 1000,
            desde: 1,
            foliosNumerados: true,
            hasta: 1000,
            inscritos: 0,
          },
          precio: {
            preventa_1: {
              desde: "2010-01-01 00:00:00",
              disponible: true,
              hasta: "2025-01-19 23:59:59",
              precio_1: 150,
            },
          },
          productosAdicionales: {},
        },
        descripcionModalidad: "Nombre de distancia",
        cantidadPersonas: 1,
        hSalidas: {
          serie_1: {
            descripcionSerie: "Salida Modalidad 1",
            hS: "0000-00-00 00:00:00",
            hsTimeStamp: 0,
            serie: 1,
          },
        },
        modalidad: 10,
        ramaCat: {
          rama_F: {
            categorias: {
              categoria_1: {
                absolutos: false,
                cantidadGanadores: 3,
                capacidad: 200,
                codigo: 1,
                edadDesde: 18,
                edadHasta: 29,
                inscritos: 0,
                serie: 1,
                minimoParticipantes: 10,
                nombreCategoria: "Libre",
                precioKey: "precio_1",
              },
            },
            rama: "F",
          },
          rama_V: {
            categorias: {
              categoria_1: {
                absolutos: false,
                cantidadGanadores: 3,
                capacidad: 200,
                codigo: 1,
                edadDesde: 18,
                edadHasta: 29,
                inscritos: 0,
                serie: 1,
                minimoParticipantes: 10,
                nombreCategoria: "Libre",
                precioKey: "precio_1",
              },
            },
            rama: "V",
          },
        },
      },
    },
    fotosEvento: {
      configuracionFotos: {
        logos: [
          {
            anchoLogo: 0.2,
            codLogo: 3,
            descripcion: "Logo Dashport",
            margen: 15,
            posicion: 1,
            rutaLogo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/logosDashport%2FDASHPORT_white_horizontal.png?alt=media&token=e9e08a40-56ae-4297-bffc-5522bcc9687a"
          }
        ],
        marcos: [
          {
            codMarco: 1,
            descripcion: "Marco Blanco",
            rutaMarco: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/MarcosFotos%2FMarcoBordeBlancoRecto.png?alt=media&token=4b64abde-f3ef-476c-9dbf-b2d3f30350be",
            tipo: "Estandar"
          },
          {
            codMarco: 2,
            descripcion: "Marco Negro",
            rutaMarco: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/MarcosFotos%2FMarcoBordeNegroRecto.png?alt=media&token=27bdf91a-264d-480a-bbf7-0a5559996828",
            tipo: "Estandar"
          }
        ]
      },
      fotografos: {
        fotografo_1: {
          ajusteHoraCamara: 0,
          codigoFotografo: 1,
          nombre: "Cámara 1"
        }
      }
    }
  };
  console.log(defaultObject);

  return (dispatch) => {
    // Se retorna la cadena completa (antes no) y se resuelve con el
    // eventoIndex ya armado, para que quien llama (el modal de carga en
    // EventCreateForm.jsx) sepa cuándo terminó la escritura y a qué evento
    // enlazar, sin tener que adivinar/releer el máximo iDEvento otra vez.
    return ref.once("value").then((snapshot) => {
      var maxEventId = Object.values(snapshot.val()).reduce((prev, current) =>
        prev.iDEvento > current.iDEvento ? prev : current
      );
      const iDEvento = maxEventId.iDEvento + 1;
      console.log("maxEventId", maxEventId);
      defaultObject.detalleEvento.iDEvento = iDEvento;
      const eventoIndex = "evento_" + iDEvento;
      return createEvent(eventoIndex, defaultObject).then(function () {
        return eventoIndex;
      });
    });
  };
}
//#################################################################
export function createEvent(eventoIndex, data) {
  console.log("Guardar datos de evento");
  if (eventoIndex) {
    // referencia a la base de datos

    console.log(data);
    return fb.db
      .ref(`${fb.EventosCompletos}/${eventoIndex}/`)
      .set(data)
      .then(function () {
        console.log("Datos Guardados");
        return fb.db
          .ref(`${fb.EventosLista}/${eventoIndex}/`)
          .set(data.detalleEvento);
      })
      .then(function () {
        console.log("Datos Guardados");
        // dispatch(
        //   createEventLog(
        //     eventoIndex,
        //     data,
        //     `${fb.EventosCompletos}/${eventoIndex}/`
        //   )
        // );
      })
      .catch(function (error) {
        console.log("Error" + error);
        throw error;
      });
  }
}
//#################################################################
export function updateEventAttribute(eventoIndex, route, data) {
  console.log("Guardar datos de evento");

  if (eventoIndex) {
    // referencia a la base de datos
    var updates = {};

    if (route.indexOf("detalleEvento") >= 0) {
      const routeNew = route.replace("detalleEvento/", "");
      updates[
        `${fb.EventosLista}/${eventoIndex}/${routeNew}/${Object.keys(data)[0]}/`
      ] = Object.values(data)[0];
    }

    updates[
      `${fb.EventosCompletos}${eventoIndex}/${route}${Object.keys(data)[0]}/`
    ] = Object.values(data)[0];

    console.log(data);
    console.log(route);
    console.log(eventoIndex);
    console.log("dataTIMING", updates);

    return (dispatch) => {
      return fb.db
        .ref()
        .update(updates)
        .then(function () {
          console.log("Datos Guardados");
          // se registra la ruta completa (incluyendo el campo modificado),
          // no solo la ruta base, para que el log identifique exactamente
          // qué campo cambió (p.ej. folios/desde, folios/hasta).
          dispatch(
            createEventLog(eventoIndex, data, route + Object.keys(data)[0])
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    };
  }
}
//#################################################################
// Escribe el valor de una subclasificación (ej. "Mérida") en cada resultado
// correspondiente — compartida por "Sincronizar valores" (origen campo
// adicional) y la confirmación de import (origen importado), que solo
// difieren en cómo arman `valoresPorBib`. updateEventAttribute no sirve acá
// porque solo escribe la primera clave de `data` (ver arriba); esto necesita
// escribir muchas rutas completas distintas en un solo .update().
export function escribirValoresSubclasificacion(
  eventoIndex,
  subclasifId,
  valoresPorBib
) {
  var updates = {};
  Object.keys(valoresPorBib || {}).forEach(function (bib) {
    updates[
      `${fb.EventosCompletos}${eventoIndex}/${fb.Resultados}${bib}/subclasificaciones/${subclasifId}`
    ] = valoresPorBib[bib];
  });

  return (dispatch) => {
    return fb.db
      .ref()
      .update(updates)
      .then(function () {
        console.log("Valores de subclasificación guardados", subclasifId);
      })
      .catch(function (error) {
        console.log("Error" + error);
        throw error;
      });
  };
}
//#################################################################
export function updateEventObject(eventoIndex, route, data) {
  console.log("Guardar datos de evento", eventoIndex, route, data);

  if (eventoIndex) {
    // referencia a la base de datos
    var updates = {};

    console.log(eventoIndex, route, data)

    updates[`${fb.EventosCompletos}/${eventoIndex}/${route}`] = data;

    return (dispatch) => {
      return fb.db
        .ref()
        .update(updates)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(createEventLog(eventoIndex, data, route));
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    };
  }
}
//#################################################################
export function createEventAttribute(eventoIndex, route, data) {
  console.log("Guardar datos");

  if (eventoIndex) {
    // referencia a la base de datos
    const finalRoute = `${fb.EventosCompletos}/${eventoIndex}/${route}/`;

    return (dispatch) => {
      return fb.db
        .ref(finalRoute)
        .set(data)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(createEventLog(eventoIndex, data, route));
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    };
  }
}
//#################################################################
export function createSubEvent(
  eventoIndex,
  data,
  userID,
  eventSubEventsRegistry
) {
  var maxModId = Object.values(eventSubEventsRegistry).reduce((prev, current) =>
    prev.codigoModalidad > current.codigoModalidad ? prev : current
  );
  const codigoModalidad = maxModId.codigoModalidad + 1;

  const camposAdicionalesModalidad =
    Object.values(eventSubEventsRegistry)[0].configModalidad
      .camposAdicionalesModalidad || null;
  const defaultObject = {
    codigoModalidad: codigoModalidad,
    userCreate: userID,
    hSalidas: {
      serie_1: {
        descripcionSerie: "Salida Modalidad 1",
        hS: "0000-00-00 00:00:00",
        hsTimeStamp: 0,
        serie: 1,
      },
    },
    configModalidad: {
      camposAdicionalesModalidad: camposAdicionalesModalidad,
      folios: {
        capacidad: 1000,
        desde: data["configModalidad/folios/desde"] || 1,
        foliosNumerados: true,
        hasta: data["configModalidad/folios/hasta"] || 1000,
        inscritos: data["configModalidad/folios/inscritos"] || 0,
      },
      precio: {
        preventa_1: {
          desde: "2010-01-01 00:00:00",
          disponible: true,
          hasta: "2025-01-19 23:59:59",
          precio_1: data["configModalidad/precio/preventa_1/precio_1"] || 150,
        },
      },
    },
    descripcionModalidad: data.descripcionModalidad || "Nombre Distancia",
    modalidad: data.modalidad || 5,
    ramaCat: {
      rama_F: {
        categorias: {
          categoria_1: {
            absolutos: false,
            cantidadGanadores: 3,
            capacidad: 200,
            codigo: 1,
            edadDesde: 18,
            edadHasta: 29,
            inscritos: 0,
            serie: 1,
            minimoParticipantes: 10,
            nombreCategoria: "Libre",
            precioKey: "precio_1",
          },
        },
        rama: "F",
      },
      rama_V: {
        categorias: {
          categoria_1: {
            absolutos: false,
            cantidadGanadores: 3,
            capacidad: 200,
            codigo: 1,
            edadDesde: 18,
            edadHasta: 29,
            inscritos: 0,
            serie: 1,
            minimoParticipantes: 10,
            nombreCategoria: "Libre",
            precioKey: "precio_1",
          },
        },
        rama: "V",
      },
    },
  };
  console.log(defaultObject);

  const route = "modalidadesInscripcion/modalidad_" + codigoModalidad;

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      console.log(data);
      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "createSubEvent" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function createSubEventTiming(
  eventoIndex,
  data,
  userID,
  eventSubEventsTiming
) {
  var maxModId = Object.values(eventSubEventsTiming).reduce((prev, current) =>
    prev.codigoModalidad > current.codigoModalidad ? prev : current
  );
  const codigoModalidad = maxModId.codigoModalidad + 1;

  const defaultObject = {
    codigoModalidad: codigoModalidad,
    userCreate: userID,
    descripcionModalidad: data.descripcionModalidad || "Nombre Distancia",
    modalidad: data.modalidad || 5,
    hSalidas: {
      serie_1: {
        descripcionSerie: "Salida Modalidad 1",
        hS: "0000-00-00 00:00:00",
        hsTimeStamp: 0,
        serie: 1,
      },
    },
    ramaCat: {
      rama_F: {
        categorias: {
          categoria_1: {
            absolutos: false,
            cantidadGanadores: 3,
            capacidad: 200,
            codigo: 1,
            edadDesde: 18,
            edadHasta: 29,
            inscritos: 0,
            serie: 1,
            minimoParticipantes: 10,
            nombreCategoria: "Libre",
            precioKey: "precio_1",
          },
        },
        rama: "F",
      },
      rama_V: {
        categorias: {
          categoria_1: {
            absolutos: false,
            cantidadGanadores: 3,
            capacidad: 200,
            codigo: 1,
            edadDesde: 18,
            edadHasta: 29,
            inscritos: 0,
            serie: 1,
            minimoParticipantes: 10,
            nombreCategoria: "Libre",
            precioKey: "precio_1",
          },
        },
        rama: "V",
      },
    },
  };
  console.log(defaultObject);

  const route = "modalidades/modalidad_" + codigoModalidad;

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      console.log(data);
      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "createSubEvent" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
// Convierte modalidadesInscripcion + un plan (incluir/excluir/agrupar/separar) en el
// objeto final de modalidades/ (crono). Función pura, sin dispatch, para poder
// reutilizarla también en la vista previa de la pantalla de planificación.
function normalizarNombreCategoria(nombre) {
  return (nombre || "").toString().trim().toLowerCase();
}

function limpiarCamposDeInscripcion(modalidad) {
  delete modalidad.configModalidad;
  delete modalidad.userCreate;
  delete modalidad.hide;
  delete modalidad.order;
  modalidad.modalidad = modalidad.modalidad / 1;
  const generos = modalidad.ramaCat || {};
  for (var gen in generos) {
    const categorias = generos[gen].categorias || {};
    for (var catKey in categorias) {
      delete categorias[catKey].camposAdicionalesKey;
      delete categorias[catKey].capacidad;
      delete categorias[catKey].inscritos;
      delete categorias[catKey].precioKey;
      categorias[catKey].serie = 1;
    }
  }
  return modalidad;
}

function limpiarCategoria(categoria) {
  const limpia = JSON.parse(JSON.stringify(categoria));
  delete limpia.camposAdicionalesKey;
  delete limpia.capacidad;
  delete limpia.inscritos;
  delete limpia.precioKey;
  limpia.serie = 1;
  return limpia;
}

function nuevoHSalidas(descripcionModalidad) {
  return {
    serie_1: {
      descripcionSerie: "Salida " + descripcionModalidad,
      hS: "0000-00-00 00:00:00",
      hsTimeStamp: 0,
      serie: 1,
    },
  };
}

// Determina, a partir de las decisiones por modalidad (incluir/excluir/
// agrupar), en qué "grupo final" cae cada modalidad de inscripción. Una
// modalidad en "incluir" cae en su propio grupo (solo ella); varias
// modalidades en "agrupar" con la misma etiqueta caen en un único grupo
// compartido. Se usa tanto para construir el resultado final como para que
// la pantalla de planificación pueda mostrar, ya agrupadas, las categorías
// disponibles para separar.
function agruparModalidadesPorDecision(decisions, registryClone) {
  const gruposOrden = [];
  const gruposPorClave = {};

  for (var modKey in registryClone) {
    const decision = (decisions && decisions[modKey]) || { action: "include" };
    if (decision.action === "exclude") continue;

    const esGrupoExplicito = decision.action === "group" && decision.groupLabel;
    const claveGrupo = esGrupoExplicito
      ? "grupo:" + decision.groupLabel
      : "solo:" + modKey;

    if (!gruposPorClave[claveGrupo]) {
      gruposPorClave[claveGrupo] = {
        clave: claveGrupo,
        nombreBase: esGrupoExplicito
          ? decision.groupLabel
          : registryClone[modKey].descripcionModalidad,
        miembros: [],
      };
      gruposOrden.push(claveGrupo);
    }
    gruposPorClave[claveGrupo].miembros.push(modKey);
  }

  return gruposOrden.map(function (clave) {
    return gruposPorClave[clave];
  });
}

// Combina las categorías (por nombre normalizado, a través de todas las
// ramas) de todos los miembros de un grupo ya resuelto por
// agruparModalidadesPorDecision. Si el grupo tiene un solo miembro, esto
// simplemente reproduce sus propias categorías 1:1.
function combinarCategoriasDeGrupo(grupo, registryClone) {
  const ramaCatCombinado = {}; // { [genKey]: { rama, categorias: { categoria_N: categoriaLimpia } } }
  const categoriaKeyPorNombre = {}; // { [genKey]: { [nombreNormalizado]: categoriaKeyFinal } }

  grupo.miembros.forEach(function (miembroKey) {
    const miembroOriginal = registryClone[miembroKey];
    const miembroCodigo = miembroOriginal.codigoModalidad;
    const generosMiembro = miembroOriginal.ramaCat || {};

    for (var genMiembro in generosMiembro) {
      const ramaMiembro = generosMiembro[genMiembro];
      if (!ramaCatCombinado[genMiembro]) {
        ramaCatCombinado[genMiembro] = { rama: ramaMiembro.rama, categorias: {} };
        categoriaKeyPorNombre[genMiembro] = {};
      }

      const categoriasMiembro = ramaMiembro.categorias || {};
      for (var catKeyMiembro in categoriasMiembro) {
        const categoriaOriginalMiembro = categoriasMiembro[catKeyMiembro];
        const nombreNorm = normalizarNombreCategoria(
          categoriaOriginalMiembro.nombreCategoria
        );
        const origen = {
          modalidad: miembroCodigo,
          genero: ramaMiembro.rama,
          categoria: categoriaOriginalMiembro.codigo,
        };

        const categoriaKeyExistente = categoriaKeyPorNombre[genMiembro][nombreNorm];
        if (categoriaKeyExistente) {
          // misma categoría (por nombre) ya aportada por otro miembro del
          // grupo -> se colapsa en la misma categoría de crono, para que el
          // crono los rankee juntos en vez de por separado.
          ramaCatCombinado[genMiembro].categorias[
            categoriaKeyExistente
          ].origenesInscripcion.push(origen);
        } else {
          const nuevoIndice =
            Object.keys(ramaCatCombinado[genMiembro].categorias).length + 1;
          const nuevaCategoriaKey = "categoria_" + nuevoIndice;
          const categoriaLimpia = limpiarCategoria(categoriaOriginalMiembro);
          categoriaLimpia.codigo = nuevoIndice;
          categoriaLimpia.origenesInscripcion = [origen];
          categoriaLimpia._nombreNormalizado = nombreNorm;
          ramaCatCombinado[genMiembro].categorias[nuevaCategoriaKey] = categoriaLimpia;
          categoriaKeyPorNombre[genMiembro][nombreNorm] = nuevaCategoriaKey;
        }
      }
    }
  });

  return ramaCatCombinado;
}

// Lista, para un grupo ya resuelto, sus categorías combinadas (una por
// nombre normalizado, a través de todas las ramas) -- lo que la pantalla de
// planificación necesita para mostrar el checklist de "separar en modalidad
// aparte" sobre el resultado YA agrupado.
export function listarCategoriasCombinadasDeGrupo(grupo, eventSubEventsRegistry) {
  const registryClone = JSON.parse(JSON.stringify(eventSubEventsRegistry || {}));
  const ramaCatCombinado = combinarCategoriasDeGrupo(grupo, registryClone);
  const porNombre = {};
  for (var genKey in ramaCatCombinado) {
    const categorias = ramaCatCombinado[genKey].categorias;
    for (var catKey in categorias) {
      const categoria = categorias[catKey];
      if (!porNombre[categoria._nombreNormalizado]) {
        porNombre[categoria._nombreNormalizado] = {
          nombreNormalizado: categoria._nombreNormalizado,
          nombreCategoria: categoria.nombreCategoria,
        };
      }
    }
  }
  return Object.values(porNombre);
}

// Calcula, a partir de las decisiones por modalidad, los grupos resultantes
// con sus categorías combinadas -- usado por la pantalla de planificación
// para renderizar el checklist de "separar" por cada grupo.
export function computeGruposConCategorias(decisions, eventSubEventsRegistry) {
  const registryClone = JSON.parse(JSON.stringify(eventSubEventsRegistry || {}));
  const grupos = agruparModalidadesPorDecision(decisions, registryClone);
  return grupos.map(function (grupo) {
    return {
      clave: grupo.clave,
      nombreBase: grupo.nombreBase,
      miembros: grupo.miembros,
      categorias: listarCategoriasCombinadasDeGrupo(grupo, eventSubEventsRegistry),
    };
  });
}

export function buildTimingModalidadesFromPlan(plan, eventSubEventsRegistry) {
  const decisions = (plan && plan.decisions) || {};
  const categoriasSeparadasPorGrupo =
    (plan && plan.categoriasSeparadasPorGrupo) || {};

  const registryClone = JSON.parse(
    JSON.stringify(eventSubEventsRegistry || {})
  );
  const resultado = {};
  let siguienteCodigo = 1;

  function agregarModalidadFinal(modalidadLimpia) {
    const codigo = siguienteCodigo++;
    modalidadLimpia.codigoModalidad = codigo;
    modalidadLimpia.hSalidas = nuevoHSalidas(
      modalidadLimpia.descripcionModalidad
    );
    resultado["modalidad_" + codigo] = modalidadLimpia;
    return codigo;
  }

  const grupos = agruparModalidadesPorDecision(decisions, registryClone);

  grupos.forEach(function (grupo) {
    const primerMiembro = grupo.miembros[0];
    const esGrupoExplicito = grupo.clave.indexOf("grupo:") === 0;
    const ramaCatCombinado = combinarCategoriasDeGrupo(grupo, registryClone);

    // Reagrupar el resultado combinado por nombre normalizado (a través de
    // todas las ramas), para poder decidir por categoría (no por rama) si
    // se separa o se queda en la modalidad base.
    const combinadoPorNombre = {};
    for (var genKey in ramaCatCombinado) {
      const categorias = ramaCatCombinado[genKey].categorias;
      for (var catKey in categorias) {
        const categoriaLimpia = categorias[catKey];
        const nombreNorm = categoriaLimpia._nombreNormalizado;
        if (!combinadoPorNombre[nombreNorm]) {
          combinadoPorNombre[nombreNorm] = {
            nombreOriginal: categoriaLimpia.nombreCategoria,
            entradas: [],
          };
        }
        combinadoPorNombre[nombreNorm].entradas.push({
          genKey: genKey,
          rama: ramaCatCombinado[genKey].rama,
          categoriaLimpia: categoriaLimpia,
        });
      }
    }

    const nombresSeparados = (categoriasSeparadasPorGrupo[grupo.clave] || []).map(
      normalizarNombreCategoria
    );

    function plantillaModalidad() {
      const base = limpiarCamposDeInscripcion(
        JSON.parse(JSON.stringify(registryClone[primerMiembro]))
      );
      if (esGrupoExplicito) {
        base.descripcionModalidad = grupo.nombreBase;
      }
      return base;
    }

    // 1) Categorías marcadas para separar: una modalidad nueva por cada una,
    // ya con ambas ramas juntas.
    Object.keys(combinadoPorNombre).forEach(function (nombreNorm) {
      if (nombresSeparados.indexOf(nombreNorm) === -1) return;

      const grupoCategoria = combinadoPorNombre[nombreNorm];
      const modalidadSplit = plantillaModalidad();
      modalidadSplit.descripcionModalidad =
        modalidadSplit.descripcionModalidad + " - " + grupoCategoria.nombreOriginal;
      modalidadSplit.ramaCat = {};

      grupoCategoria.entradas.forEach(function (entrada) {
        const categoriaFinal = JSON.parse(
          JSON.stringify(entrada.categoriaLimpia)
        );
        delete categoriaFinal._nombreNormalizado;
        categoriaFinal.codigo = 1;
        modalidadSplit.ramaCat[entrada.genKey] = {
          rama: entrada.rama,
          categorias: { categoria_1: categoriaFinal },
        };
      });

      agregarModalidadFinal(modalidadSplit);
    });

    // 2) Categorías que no se separaron: quedan juntas en una sola modalidad
    // base (renumeradas), que es el resultado normal de "incluir" o
    // "agrupar" cuando no se separa nada.
    const nombresRestantes = Object.keys(combinadoPorNombre).filter(
      function (nombreNorm) {
        return nombresSeparados.indexOf(nombreNorm) === -1;
      }
    );

    if (nombresRestantes.length > 0) {
      const modalidadBase = plantillaModalidad();
      modalidadBase.ramaCat = {};

      nombresRestantes.forEach(function (nombreNorm) {
        combinadoPorNombre[nombreNorm].entradas.forEach(function (entrada) {
          if (!modalidadBase.ramaCat[entrada.genKey]) {
            modalidadBase.ramaCat[entrada.genKey] = {
              rama: entrada.rama,
              categorias: {},
            };
          }
          const nuevoIndice =
            Object.keys(modalidadBase.ramaCat[entrada.genKey].categorias)
              .length + 1;
          const categoriaFinal = JSON.parse(
            JSON.stringify(entrada.categoriaLimpia)
          );
          delete categoriaFinal._nombreNormalizado;
          categoriaFinal.codigo = nuevoIndice;
          modalidadBase.ramaCat[entrada.genKey].categorias[
            "categoria_" + nuevoIndice
          ] = categoriaFinal;
        });
      });

      agregarModalidadFinal(modalidadBase);
    }
  });

  return resultado;
}

export function generateTimingModalidadesFromPlan(
  eventoIndex,
  plan,
  eventSubEventsRegistry
) {
  const resultado = buildTimingModalidadesFromPlan(plan, eventSubEventsRegistry);
  const route = "modalidades/";

  return (dispatch) => {
    const updates = {};
    updates[`${fb.EventosCompletos}/${eventoIndex}/${route}`] = resultado;

    return fb.db
      .ref()
      .update(updates)
      .then(function () {
        dispatch(
          createEventLog(
            eventoIndex,
            {
              action: "generateTimingModalidadesFromPlan",
              totalModalidades: Object.keys(resultado).length,
            },
            route
          )
        );
        return resultado;
      })
      .catch(function (error) {
        console.log("Error generando modalidades de crono desde el plan:", error);
        throw error;
      });
  };
}
//#################################################################
export function createControlPointTiming(eventoIndex, userID, controlPoints) {
  var maxModId = Object.values(controlPoints).reduce((prev, current) =>
    prev.kNroPunto > current.kNroPunto ? prev : current
  );
  const kNroPunto = maxModId.kNroPunto + 1;

  const defaultObject = {
    descripcionFinalPunto: "Control Número " + kNroPunto,
    flotante: false,
    kNroPunto: kNroPunto,
    lat: 1,
    lng: 1,
    modalidadesPuntoDeControl: {},
  };

  const route = "puntosDeControl/kPC_" + kNroPunto;
  return (dispatch) => {
    console.log("Punto de control creado");
    if (eventoIndex) {
      // referencia a la base de datos

      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            showSnackbar(true, "Punto de control creado correctamente ", 5000)
          );

          dispatch(
            createEventLog(eventoIndex, { action: "createSubEvent" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function createControlPointLap(
  eventoIndex,
  userID,
  controlPointIndex,
  controlPoints,
  distanceIndex
) {
  const laps =
    controlPoints["kPC_" + controlPointIndex].modalidadesPuntoDeControl[
      "modalidad_" + distanceIndex
    ].laps;
  const distance =
    controlPoints["kPC_" + controlPointIndex].modalidadesPuntoDeControl[
      "modalidad_" + distanceIndex
    ].modalidad;

  var maxModId = Object.values(laps).reduce((prev, current) =>
    prev.lap > current.lap ? prev : current
  );
  const lap = maxModId.lap + 1;

  const defaultObject = {
    descripcionPunto: "Lap Nro:" + lap,
    kilometro: distance / 2,
    lap: lap,
    maxTime: "00:07:00",
    minTime: "00:00:01",
    tipoControl: 2,
    unidadPaso: "min/k",
  };

  const route =
    "puntosDeControl/kPC_" +
    controlPointIndex +
    "/modalidadesPuntoDeControl/modalidad_" +
    distanceIndex +
    "/laps/lap_" +
    lap;
  return (dispatch) => {
    console.log("Punto de control creado");
    if (eventoIndex) {
      // referencia a la base de datos

      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(showSnackbar(true, "Vuelta Creada correctamente ", 5000));

          dispatch(
            createEventLog(eventoIndex, { action: "createSubEvent" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function deleteSubEvent(
  eventoIndex,
  userID,
  eventSubEventsRegistry,
  subEventIndex
) {
  const route = "modalidadesInscripcion/" + subEventIndex + "/";

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(null)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "deleteSubEvent" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function deleteInventoryItem(eventoIndex, itemKey) {
  const route = "inscripcionesConfiguracion/inventarios/" + itemKey + "/";

  return (dispatch) => {
    if (eventoIndex) {
      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(null)
        .then(function () {
          dispatch(
            createEventLog(eventoIndex, { action: "deleteInventoryItem" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function createCategory(
  eventoIndex,
  data,
  userID,
  eventSubEventsRegistry,
  subEventIndex,
  gender
) {
  const categories =
    eventSubEventsRegistry[subEventIndex].ramaCat[gender].categorias;
  var maxModId = Object.values(categories).reduce((prev, current) =>
    prev.codigo > current.codigo ? prev : current
  );
  const codigo = maxModId.codigo + 1;

  const defaultObject = {
    absolutos: false,
    cantidadGanadores: 3,
    codigo: codigo,
    edadDesde: data.edadDesde || 18,
    edadHasta: data.edadHasta || 29,
    inscritos: 0,
    serie: 1,
    minimoParticipantes: 10,
    nombreCategoria: data.nombreCategoria || "Libre",
    precioKey: "precio_1",
  };
  console.log(defaultObject);

  const route =
    "modalidadesInscripcion/" +
    subEventIndex +
    "/ramaCat/" +
    gender +
    "/categorias/categoria_" +
    codigo +
    "/";

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      console.log(data);
      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "createCategory" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function createCategoryTiming(
  eventoIndex,
  data,
  userID,
  eventSubEventsTiming,
  subEventIndex,
  gender
) {
  const categories =
    eventSubEventsTiming[subEventIndex].ramaCat[gender].categorias;
  var maxModId = Object.values(categories).reduce((prev, current) =>
    prev.codigo > current.codigo ? prev : current
  );
  const codigo = maxModId.codigo + 1;

  const defaultObject = {
    absolutos: false,
    cantidadGanadores: data.cantidadGanadores || 3,
    codigo: codigo,
    edadDesde: data.edadDesde || 18,
    edadHasta: data.edadHasta || 29,
    inscritos: 0,
    serie: 1,
    minimoParticipantes: 10,
    nombreCategoria: data.nombreCategoria || "Libre",
    precioKey: "precio_1",
  };
  console.log(defaultObject);

  const route =
    "modalidades/" +
    subEventIndex +
    "/ramaCat/" +
    gender +
    "/categorias/categoria_" +
    codigo +
    "/";

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      console.log(data);
      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "createCategory" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function createCategoryTimingAsolutes(
  eventoIndex,
  data,
  userID,
  eventSubEventsTiming,
  subEventIndex,
  gender,
  deleteCategory
) {
  const codigo = 0;

  let defaultObject = {
    absolutos: true,
    cantidadGanadores: data.cantidadGanadores || 3,
    codigo: codigo,
    edadDesde: 0,
    edadHasta: 99,
    inscritos: 0,
    serie: 1,
    minimoParticipantes: 10,
    nombreCategoria: data.nombreCategoria || "Absolutos",
    precioKey: "precio_1",
  };
  if (deleteCategory) {
    defaultObject = null;
  }
  console.log(defaultObject);

  const route =
    "modalidades/" +
    subEventIndex +
    "/ramaCat/" +
    gender +
    "/categorias/categoria_" +
    codigo +
    "/";

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      console.log(data);
      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "createCategory" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}

//#################################################################
export function createStartTiming(
  eventoIndex,
  data,
  userID,
  eventSubEventsTiming,
  subEventIndex
) {
  const starts = eventSubEventsTiming[subEventIndex].hSalidas;
  var maxModId = Object.values(starts).reduce((prev, current) =>
    prev.serie > current.serie ? prev : current
  );
  const codigo = maxModId.serie + 1;

  const defaultObject = {
    descripcionSerie: "Salida " + codigo,
    hS: "0000-00-00 00:00:00",
    serie: codigo,
  };
  console.log(defaultObject);

  const route =
    "modalidades/" + subEventIndex + "/hSalidas/serie_" + codigo + "/";

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      console.log(data);
      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(defaultObject)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "createStart" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function deleteCategory(
  eventoIndex,
  userID,
  eventSubEventsRegistry,
  subEventIndex,
  gender,
  categoryCode
) {
  const route =
    "modalidadesInscripcion/" +
    subEventIndex +
    "/ramaCat/" +
    gender +
    "/categorias/categoria_" +
    categoryCode +
    "/";

  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (eventoIndex) {
      // referencia a la base de datos

      return fb.db
        .ref(`${fb.EventosCompletos}/${eventoIndex}/${route}/`)
        .set(null)
        .then(function () {
          console.log("Datos Guardados");
          dispatch(
            createEventLog(eventoIndex, { action: "deleteSubEvent" }, route)
          );
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################

export function detalleEvento(eventoIndex) {
  console.log("detalle evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.DetalleEvento}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.EVENT_DETAIL,
        eventDetail: snapshot.val(),
      });
    });
  };
}
//#################################################################
let lastEventIndexConfiguracionEvento = null;
let activeListenersConfiguracionEvento = {};

// Mismo patrón que registryConfiguration/registryAutorizedUsers
// (registry-actions.js): sin esto, cambiar de evento sin recargar la
// página deja el listener del evento anterior escuchando y puede
// sobrescribir eventConfiguration con datos del evento equivocado.
export function configuracionEvento(eventoIndex) {
  console.log("configuracion evento");

  if (
    lastEventIndexConfiguracionEvento &&
    activeListenersConfiguracionEvento[lastEventIndexConfiguracionEvento]
  ) {
    activeListenersConfiguracionEvento[
      lastEventIndexConfiguracionEvento
    ].off();
    delete activeListenersConfiguracionEvento[
      lastEventIndexConfiguracionEvento
    ];
  }
  lastEventIndexConfiguracionEvento = eventoIndex;

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.Configuracion}`
  );
  activeListenersConfiguracionEvento[eventoIndex] = ref;

  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.EVENT_CONFIGURATION,
        eventConfiguration: snapshot.val(),
      });
    });
  };
}
//#################################################################
export function resultadosEvento(eventoIndex) {
  console.log("Resultados evento");
  var ref = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.Resultados}`);
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      var data = snapshot.val();
      var ResultadosEvento = [];
      for (var indice in data) {
        ResultadosEvento.push(data[indice]);
      }
      dispatch({
        type: types.EVENT_RESULTS,
        eventResults: ResultadosEvento,
      });
    });
  };
}
//#################################################################
export function resultadosEventoNewOld(eventoIndex) {
  console.log("resultadosEventoNew");
  var ref = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.Resultados}`);
  var ref1 = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.Modalidades}`
  );
  return (dispatch) => {
    let eventSubEventsNew = {};
    console.log("absolutos", eventSubEventsNew);

    ref1
      .once("value")
      .then((modalidades) => {
        eventSubEventsNew = modalidades.val();
        console.log("absolutos", eventSubEventsNew);
        return ref.once("value");
      })
      .then((snapshot) => {
        console.log("absolutos", snapshot.val());
        if (snapshot.val()) {
          let ResultadosEvento = Object.values(snapshot.val());

          dispatch({
            type: types.EVENT_RESULTS,
            eventResultsOriginal: ResultadosEvento,
            eventResults: calculatePositions(
              ResultadosEvento,
              eventSubEventsNew
            ),
          });
        } else {
          dispatch({
            type: types.EVENT_RESULTS,
            eventResultsOriginal: [],
            eventResults: [],
          });
        }
      });

    ref.on("child_changed", (snapshot) => {
      console.log("results", snapshot);
      const dato = snapshot.val();
      const eventResults = store.getState().events.eventResultsOriginal;

      const index = eventResults.findIndex((obj) => {
        return obj.num === dato.num;
      });

      eventResults[index] = dato;

      console.log("child chaged");
      dispatch({
        type: types.EVENT_RESULTS,
        eventResultsOriginal: eventResults,
        eventResults: calculatePositions(eventResults, eventSubEventsNew),
      });
    });
    ref.limitToLast(1).on("child_added", (snapshot) => {
      console.log("results", snapshot.val());
      const dato = snapshot.val();
      let eventResults = store.getState().events.eventResultsOriginal;
      console.log("results1", eventResults);

      if (eventResults) {
        eventResults.push(dato);

        console.log("child added");
        dispatch({
          type: types.EVENT_RESULTS,
          eventResultsOriginal: eventResults,
          eventResults: calculatePositions(eventResults, eventSubEventsNew),
        });
      }
    });
    ref.on("child_removed", (snapshot) => {
      console.log("results", snapshot.val());
      const dato = snapshot.val();
      const eventResults = store.getState().events.eventResultsOriginal;

      const index = eventResults.findIndex((obj) => {
        return obj.num === dato.num;
      });

      delete eventResults[index];

      console.log("child removed");
      dispatch({
        type: types.EVENT_RESULTS,
        eventResultsOriginal: eventResults,
        eventResults: calculatePositions(eventResults, eventSubEventsNew),
      });
    });
  };
}
//#################################################################

let lastEventIndexResultadosNew = null;
let activeListenersResultadosNew = {};

export function resultadosEventoNew(eventoIndex) {
  const ref = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.Resultados}`);
  const ref1 = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.Modalidades}`);

  // Solo "ref" (resultados) tiene listeners persistentes (child_added/
  // changed/removed, más abajo) — "ref1" (modalidades) solo se lee una vez
  // con .once() para la carga inicial, no necesita limpieza. Mismo patrón
  // que el resto: cerrar el listener del evento anterior antes de abrir el
  // nuevo, sin tocar nada del buffering/adaptive-delay de abajo.
  if (
    lastEventIndexResultadosNew &&
    activeListenersResultadosNew[lastEventIndexResultadosNew]
  ) {
    activeListenersResultadosNew[lastEventIndexResultadosNew].off();
    delete activeListenersResultadosNew[lastEventIndexResultadosNew];
  }
  lastEventIndexResultadosNew = eventoIndex;
  activeListenersResultadosNew[eventoIndex] = ref;

  return (dispatch) => {
    let eventSubEventsNew = {};

    // ====== adaptive burst control ======
    let burstCount = 0;
    let burstWindowStart = 0;

    const baseDelay = 500;
    const maxDelay = 2000;

    const getAdaptiveDelay = () => {
      const now = Date.now();
      const bulk = !!window.__DASHPORT_BULK_MODE__;

      // Ventana de 1s para detectar “burst”
      if (burstWindowStart === 0 || now - burstWindowStart > 1000) {
        burstWindowStart = now;
        burstCount = 0;
      }
      burstCount++;

      // Si bulk: siempre alto
      if (bulk) return 2000;

      // Si hay muchos eventos/segundo, sube delay
      // Ajusta umbrales a gusto:
      if (burstCount > 400) return 8000;
      if (burstCount > 200) return 5000;
      if (burstCount > 80) return 2000;

      return baseDelay;
    };

    // ====== buffers ======
    const upsertsByNum = {}; // { "123": dato }
    const removedNums = new Set();
    let dirty = false;

    let flushTimer = null;

    const flush = ({ forceRecalc = false } = {}) => {
      flushTimer = null;
      if (!dirty) return;

      const state = store.getState().events;
      const current = (state.eventResultsOriginal || []).filter(Boolean);

      // index por num
      const map = new Map(current.map((r) => [Number(r.num), r]));

      // removes
      if (removedNums.size) {
        removedNums.forEach((n) => map.delete(n));
        removedNums.clear();
      }

      // upserts
      Object.entries(upsertsByNum).forEach(([numStr, dato]) => {
        map.set(Number(numStr), dato);
        delete upsertsByNum[numStr];
      });

      dirty = false;

      const merged = Array.from(map.values());

      const bulk = !!window.__DASHPORT_BULK_MODE__;

      // ✅ clave: NO recalcular mientras bulk (a menos que lo forces)
      const shouldRecalc = forceRecalc || !bulk;

      dispatch({
        type: types.EVENT_RESULTS,
        eventResultsOriginal: merged,
        eventResults: shouldRecalc
          ? calculatePositions(merged, eventSubEventsNew)
          : state.eventResults, // mantiene lo último calculado
      });
    };

    const scheduleFlush = () => {
      dirty = true;
      if (flushTimer) return;

      const delay = getAdaptiveDelay();
      flushTimer = setTimeout(() => flush({ forceRecalc: false }), delay);
    };

    const queueUpsert = (dato) => {
      if (!dato) return;
      const num = Number(dato.num);
      if (Number.isNaN(num)) return;
      upsertsByNum[String(num)] = dato;
      scheduleFlush();
    };

    const queueRemove = (dato) => {
      if (!dato) return;
      const num = Number(dato.num);
      if (Number.isNaN(num)) return;
      removedNums.add(num);
      scheduleFlush();
    };

    // ✅ Exponer un “flush final” para usarlo desde tu UI cuando termine el bulk
    window.__DASHPORT_FORCE_RESULTS_RECALC__ = () => {
      // cancela timer y recalcula una sola vez
      if (flushTimer) {
        clearTimeout(flushTimer);
        flushTimer = null;
      }
      flush({ forceRecalc: true });
    };

    // ====== carga inicial ======
    ref1
      .once("value")
      .then((modalidades) => {
        eventSubEventsNew = modalidades.val() || {};
        return ref.once("value");
      })
      .then((snapshot) => {
        const val = snapshot.val();
        if (val) {
          const ResultadosEvento = Object.values(val).filter(Boolean);
          dispatch({
            type: types.EVENT_RESULTS,
            eventResultsOriginal: ResultadosEvento,
            eventResults: calculatePositions(ResultadosEvento, eventSubEventsNew),
          });
        } else {
          dispatch({
            type: types.EVENT_RESULTS,
            eventResultsOriginal: [],
            eventResults: [],
          });
        }
      });

    // ====== listeners ======
    ref.on("child_changed", (snapshot) => queueUpsert(snapshot.val()));
    ref.on("child_added", (snapshot) => queueUpsert(snapshot.val()));
    ref.on("child_removed", (snapshot) => queueRemove(snapshot.val()));
  };
}

//#################################################################
export function getAllRegistriesNew(eventoIndex) {
  console.log("regitros recibidos del evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.RegistrosJuez}`
  );
  return (dispatch) => {
    let eventSubEventsNew = {};
    console.log("absolutos", eventSubEventsNew);

    ref.once("value").then((snapshot) => {
      console.log("registriesEvent", snapshot.val());
      if (snapshot.val()) {
        let RegistriesEvent = Object.values(snapshot.val());

        dispatch({
          type: types.EVENT_RESULTS_REGISTRY_OBJECT,
          eventResultsRegistriesObject: snapshot.val(),
        });
        dispatch({
          type: types.EVENT_RESULTS_REGISTRY,
          eventResultsRegistries: RegistriesEvent,
        });
      } else {
        dispatch({
          type: types.EVENT_RESULTS_REGISTRY,
          eventResultsRegistries: [],
        });
      }
    });

    ref.on("child_changed", (snapshot) => {
      console.log("results", snapshot.val());
      const dato = Object.values(snapshot.val());
      let eventResultsRegistriesObject = store.getState().events
        .eventResultsRegistriesObject;


      eventResultsRegistriesObject["num_" + dato[0].numero] = dato;

      dispatch({
        type: types.EVENT_RESULTS_REGISTRY_OBJECT,
        eventResultsRegistriesObject: { ...eventResultsRegistriesObject },
      });
    });
    ref.limitToLast(1).on("child_added", (snapshot) => {
      const dato = Object.values(snapshot.val());
      let eventResultsRegistriesObject = store.getState().events
        .eventResultsRegistriesObject;


      if (eventResultsRegistriesObject) {
        eventResultsRegistriesObject["num_" + dato[0].numero] = dato;
      }

      dispatch({
        type: types.EVENT_RESULTS_REGISTRY_OBJECT,
        eventResultsRegistriesObject: { ...eventResultsRegistriesObject },
      });
    });
    ref.on("child_removed", (snapshot) => {
      const dato = Object.values(snapshot.val());
      let eventResultsRegistriesObject = store.getState().events
        .eventResultsRegistriesObject;


      delete eventResultsRegistriesObject["num_" + dato[0].numero];

      dispatch({
        type: types.EVENT_RESULTS_REGISTRY_OBJECT,
        eventResultsRegistriesObject: { ...eventResultsRegistriesObject },
      });
    });
  };
}
//#################################################################
export function getAllRegistries(eventoIndex) {
  console.log("regitros recibidos del evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.RegistrosJuez}`
  );
  return (dispatch) => {
    let eventSubEventsNew = {};
    console.log("absolutos", eventSubEventsNew);

    ref.once("value").then((snapshot) => {
      console.log("registriesEvent", snapshot.val());
      if (snapshot.val()) {
        let RegistriesEvent = Object.values(snapshot.val());

        dispatch({
          type: types.EVENT_RESULTS_REGISTRY_OBJECT,
          eventResultsRegistriesObject: snapshot.val(),
        });
        dispatch({
          type: types.EVENT_RESULTS_REGISTRY,
          eventResultsRegistries: RegistriesEvent,
        });
      } else {
        dispatch({
          type: types.EVENT_RESULTS_REGISTRY,
          eventResultsRegistries: [],
        });
      }
    });

    ref.on("child_changed", (snapshot) => {
      console.log("results", snapshot.val());
      const dato = Object.values(snapshot.val());
      let eventResultsRegistriesObject = store.getState().events
        .eventResultsRegistriesObject;


      eventResultsRegistriesObject["num_" + dato[0].numero] = dato;

      dispatch({
        type: types.EVENT_RESULTS_REGISTRY_OBJECT,
        eventResultsRegistriesObject: { ...eventResultsRegistriesObject },
      });
    });
    ref.limitToLast(1).on("child_added", (snapshot) => {
      const dato = Object.values(snapshot.val());
      let eventResultsRegistriesObject = store.getState().events
        .eventResultsRegistriesObject;


      if (eventResultsRegistriesObject) {
        eventResultsRegistriesObject["num_" + dato[0].numero] = dato;
      }

      dispatch({
        type: types.EVENT_RESULTS_REGISTRY_OBJECT,
        eventResultsRegistriesObject: { ...eventResultsRegistriesObject },
      });
    });
    ref.on("child_removed", (snapshot) => {
      const dato = Object.values(snapshot.val());
      let eventResultsRegistriesObject = store.getState().events
        .eventResultsRegistriesObject;


      delete eventResultsRegistriesObject["num_" + dato[0].numero];

      dispatch({
        type: types.EVENT_RESULTS_REGISTRY_OBJECT,
        eventResultsRegistriesObject: { ...eventResultsRegistriesObject },
      });
    });
  };
}
//#################################################################
export function athleteJuezRegistries(eventoIndex, number) {
  console.log("registry Juez");

  console.log("registry Juez", eventoIndex);
  console.log("registry Juez", number);

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.RegistrosJuez}/num_${number}`
  );
  return (dispatch) => {
    dispatch({
      type: types.ATHLETE_JUEZ_REGISTRY,
      registryJuez: null,
    });

    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      var data = snapshot.val();
      var registryJuez = [];
      for (var indice in data) {
        registryJuez.push({ ...data[indice], index: indice });
      }
      dispatch({
        type: types.ATHLETE_JUEZ_REGISTRY,
        registryJuez: registryJuez,
        number: number,
      });
    });
  };
}
//#################################################################
export function getLocalRegistries(eventid, kPuntoControl) {
  return (dispatch) => {
    console.log(
      "Obtener datos del local storage para ese evento y punto de control"
    );
    dispatch({
      type: types.LOCAL_REGISTRIES,
      localRegistries: {},
    });

    const registries = JSON.parse(
      localStorage.getItem("DASHPORT/" + eventid + "/" + kPuntoControl)
    );
    console.log("registries", registries);
    if (registries) {
      dispatch({
        type: types.LOCAL_REGISTRIES,
        localRegistries: registries,
      });
    }
  };
}
//#################################################################
export function createJuezRegistryNew(
  registry,
  registries,
  eventid,
  kPuntoControl,
  resend
) {
  return (dispatch) => {
    console.log("Guardar datos de evento");
    let updates = {};

    // referencia a la base de datos

    console.log("numero", registry, registries);

    var key;

    if (resend) {
      key = registry.id;
      delete registry.id;
      delete registry.sync;

      updates[
        `${fb.EventosCompletos}/${"evento_" + registry.iDEvento}/${fb.RegistrosJuez
        }/${"num_" + registry.numero}/${key}/`
      ] = registry;
    } else {
      key = fb.db
        .ref()
        .child(
          `${fb.EventosCompletos}/${"evento_" + registry.iDEvento}/${fb.RegistrosJuez
          }/${"num_" + registry.numero}/`
        )
        .push().key;

      updates[
        `${fb.EventosCompletos}/${"evento_" + registry.iDEvento}/${fb.RegistrosJuez
        }/${"num_" + registry.numero}/${key}/`
      ] = registry;

      registries[key] = { ...registry, sync: false, id: key };

      localStorage.setItem(
        "DASHPORT/" + eventid + "/" + kPuntoControl,
        JSON.stringify({ ...registries })
      );
      dispatch({
        type: types.LOCAL_REGISTRIES,
        localRegistries: registries,
      });
    }

    return fb.db
      .ref()
      .update(updates)
      .then((data) => {
        registries[key] = { ...registry, sync: true, id: key };

        console.log("numero", registries);

        localStorage.setItem(
          "DASHPORT/" + eventid + "/" + kPuntoControl,
          JSON.stringify({ ...registries })
        );

        console.log("Datos Guardados", data);
        dispatch({
          type: types.LOCAL_REGISTRIES,
          localRegistries: registries,
        });
      })
      .catch(function (error) {
        console.log("Error" + error);
      });
  };
}
//#################################################################
export function deleteRegistry(registry, registries, eventid, kPuntoControl) {
  return (dispatch) => {
    console.log("Guardar datos de evento");
    let updates = {};

    // referencia a la base de datos

    const key = registry.id;
    delete registry.id;
    delete registry.sync;

    console.log("numero", registry, registries);
    updates[
      `${fb.EventosCompletos}/${"evento_" + registry.iDEvento}/${fb.RegistrosJuez
      }/${"num_" + registry.numero}/${key}/`
    ] = registry;

    registries[key] = { ...registry, sync: false, id: key };

    dispatch({
      type: types.LOCAL_REGISTRIES,
      localRegistries: registries,
    });
    localStorage.setItem(
      "DASHPORT/" + eventid + "/" + kPuntoControl,
      JSON.stringify({ ...registries })
    );

    return fb.db
      .ref()
      .update(updates)
      .then((data) => {
        registries[key] = { ...registry, sync: true, id: key };

        console.log("numero", registries);

        localStorage.setItem(
          "DASHPORT/" + eventid + "/" + kPuntoControl,
          JSON.stringify({ ...registries })
        );

        console.log("Datos Guardados", data);
        dispatch({
          type: types.LOCAL_REGISTRIES,
          localRegistries: registries,
        });
      })
      .catch(function (error) {
        console.log("Error" + error);
      });
  };
}
//#################################################################
export function createJuezRegistry(registry, update, index) {
  return (dispatch) => {
    console.log("Guardar datos de evento");
    if (!update) {
      // referencia a la base de datos

      return fb.db
        .ref(
          `${fb.EventosCompletos}/${"evento_" + registry.iDEvento}/${fb.RegistrosJuez
          }/${"num_" + registry.numero}/`
        )
        .push()
        .set(registry)
        .then((data) => {
          console.log("Datos Guardados", data);
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    } else {
      var updates = {};
      updates[
        `${fb.EventosCompletos}/${"evento_" + registry.iDEvento}/${fb.RegistrosJuez
        }/${"num_" + registry.numero}/${index}`
      ] = registry;
      console.log("updates", updates);
      return fb.db
        .ref()
        .update(updates)
        .then(function () {
          console.log("Datos Guardados");
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    }
  };
}
//#################################################################
export function updateAthleteResult(eventIndex, number, changeObject) {
  return (dispatch) => {
    console.log("Guardar datos de evento");
    console.log("updateAthleteResult", changeObject);

    var updates = {};
    for (var i in changeObject) {
      updates[
        `${fb.EventosCompletos}/${eventIndex}/${fb.Resultados}/${"num_" +
        number}/${i}`
      ] = changeObject[i];
    }

    console.log(updates);
    return fb.db
      .ref()
      .update(updates)
      .then(function () {
        console.log("Datos Guardados");
      })
      .catch(function (error) {
        console.log("Error" + error);
      });
  };
}
//#################################################################
let lastEventIndexPuntosControl = null;
let activeListenersPuntosControl = {};

export function getPuntosControl(eventoIndex) {
  console.log("detalle evento" + eventoIndex);

  if (
    lastEventIndexPuntosControl &&
    activeListenersPuntosControl[lastEventIndexPuntosControl]
  ) {
    activeListenersPuntosControl[lastEventIndexPuntosControl].off();
    delete activeListenersPuntosControl[lastEventIndexPuntosControl];
  }
  lastEventIndexPuntosControl = eventoIndex;

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.PuntosDeControl}`
  );
  activeListenersPuntosControl[eventoIndex] = ref;

  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.EVENT_POINTS_CONTROLS,
        puntosControl: snapshot,
      });
    });
  };
}
//#################################################################
export function eventPhotoConfiguration(eventoIndex) {
  console.log("Configuracion de fotos" + eventoIndex);
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.fotosEventoRuta}${fb.configuracionFotosRuta}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_PHOTOS_CONFIGURATION,
        eventPhotoConfiguration: snapshot.val(),
      });
    });
  };
}
//#################################################################
export function eventPhotosFunc(eventoIndex) {
  var ref = fb.db.ref(
    `${fb.EventosCompletos}${eventoIndex}/${fb.fotosEventoRuta}`
  );


  return (dispatch) => {
    ref
      .once("value", (snapshot) => {
        console.log("fechaHoraMeta", snapshot.val());
        dispatch({
          type: types.EVENT_PHOTOS,
          eventPhotos: snapshot.val(),
        });
      });
  };
}
//#################################################################
// Escritura múltiple y atómica para la vista de "Cronos / Relojes": cada
// entrada de "updates" es una ruta relativa a modalidades/ (ej.
// "modalidad_1/hSalidas/serie_2/hS") con su valor nuevo. Se usa para
// Iniciar/Reiniciar/Igualar sobre varias series seleccionadas a la vez en
// una sola escritura (todas con exactamente la misma marca de tiempo
// cuando aplica), en vez de ir una por una como ya hace SpecificStart.jsx
// para una sola serie.
export function actualizarHorasSalidas(eventoIndex, updates) {
  const fullUpdates = {};
  Object.keys(updates).forEach((ruta) => {
    fullUpdates[`${fb.EventosCompletos}${eventoIndex}/${fb.Modalidades}${ruta}`] =
      updates[ruta];
  });
  return () => fb.db.ref().update(fullUpdates);
}
//#################################################################
export function eventConvocatory(eventoIndex) {
  console.log("Convatoria Evento evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.Convocatoria}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_CONVOCATORY,
        eventConvocatory: snapshot.val(),
      });
    });
  };
}
//#################################################################
export function eventAutorizacionJuez(eventoIndex) {
  console.log("Jueces Evento evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.AutorizacionJuez}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_AUTORIZACION_JUEZ,
        autorizacionJuez: snapshot.val(),
      });
    });
  };
}
//#################################################################
export function eventWeb(eventoIndex) {
  console.log("Web Evento evento");
  var ref = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.web}`);
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_WEB,
        eventWeb: snapshot.val(),
      });
    });
  };
}
//#################################################################
let lastEventIndexSubEvents = null;
let activeListenersSubEvents = {};

export function eventSubEvents(eventoIndex) {
  console.log("Convatoria Evento evento");

  if (
    lastEventIndexSubEvents &&
    activeListenersSubEvents[lastEventIndexSubEvents]
  ) {
    activeListenersSubEvents[lastEventIndexSubEvents].off();
    delete activeListenersSubEvents[lastEventIndexSubEvents];
  }
  lastEventIndexSubEvents = eventoIndex;

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.Modalidades}`
  );
  activeListenersSubEvents[eventoIndex] = ref;

  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_SUBEVENTS,
        eventSubEvents: snapshot.val(),
        eventSubEventsSnap: snapshot,
      });
    });
  };
}
//#################################################################
let lastEventIndexSubEventsRegistry = null;
let activeListenersSubEventsRegistry = {};

// AuthorizedUsersShow.jsx (y otros) dispatchan esto en cada cambio de
// evento — sin esta limpieza, el listener del evento anterior se queda
// escuchando y puede sobrescribir eventSubEventsRegistry con datos del
// evento equivocado al navegar sin recargar la página. Mismo patrón que
// registryConfiguration/registryAutorizedUsers en registry-actions.js.
export function eventSubEventsRegistry(eventoIndex) {
  console.log("Convatoria Evento evento");

  if (
    lastEventIndexSubEventsRegistry &&
    activeListenersSubEventsRegistry[lastEventIndexSubEventsRegistry]
  ) {
    activeListenersSubEventsRegistry[lastEventIndexSubEventsRegistry].off();
    delete activeListenersSubEventsRegistry[lastEventIndexSubEventsRegistry];
  }
  lastEventIndexSubEventsRegistry = eventoIndex;

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.ModalidadesInscripciones}`
  );
  activeListenersSubEventsRegistry[eventoIndex] = ref;

  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_SUBEVENTS_REGISTRY,
        eventSubEventsRegistry: snapshot.val(),
        eventSubEventsRegistrySnap: snapshot,
      });
    });
  };
}
//#################################################################
let lastEventIndexJuecesEvento = null;
let activeListenersJuecesEvento = {};

export function juecesEvento(eventoIndex) {
  console.log("jueces Evento");

  if (
    lastEventIndexJuecesEvento &&
    activeListenersJuecesEvento[lastEventIndexJuecesEvento]
  ) {
    activeListenersJuecesEvento[lastEventIndexJuecesEvento].off();
    delete activeListenersJuecesEvento[lastEventIndexJuecesEvento];
  }
  lastEventIndexJuecesEvento = eventoIndex;

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.JuecesEvento}`
  );
  activeListenersJuecesEvento[eventoIndex] = ref;

  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_USERS,
        eventUsers: snapshot.val(),
      });
    });
  };
}
//#################################################################
export function getDepositsList(eventoIndex) {
  console.log("jueces Evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.Deposits}/${fb.DepositsList}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      const data = snapshot.val();
      for (var i in data) {
        data[i] = { ...data[i], index: i };
      }
      dispatch({
        type: types.EVENT_DEPOSITS_LIST,
        eventDepositsList: data,
      });
    });
  };
}
//#################################################################
export function getDepositsRequested(eventoIndex) {
  console.log("jueces Evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.Deposits}/${fb.DepositsRequested}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      const data = snapshot.val();
      for (var i in data) {
        data[i] = { ...data[i], index: i };
      }
      dispatch({
        type: types.EVENT_DEPOSITS_REQUESTED,
        eventDepositsRequested: data,
      });
    });
  };
}
//#################################################################
export function setEventAccount(eventIndex, report) {
  return (dispatch) => {
    console.log("Guardar reporte del evento");
    var updates = {};
    updates[`${fb.eventsAccount}/${eventIndex}`] = report;

    return fb.db
      .ref()
      .update(updates)
      .then(function () {
        console.log("Datos Guardados");
      })
      .catch(function (error) {
        console.log("Error" + error);
      });
  };
}
//#################################################################
export function getEventsAcccount() {
  console.log("jueces Evento");
  var ref = fb.db.ref(`${fb.eventsAccount}`);
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      const data = snapshot.val();
      dispatch({
        type: types.EVENTS_ACCOUNT,
        eventsAccount: data,
      });
    });
  };
}
//#################################################################
export function getDepositsUserList(eventoIndex) {
  console.log("jueces Evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.Deposits}/${fb.UsersList}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_DEPOSITS_USERS,
        eventDepositsUsers: snapshot.val(),
      });
    });
  };
} //#################################################################
export function customStrings(eventoIndex) {
  console.log("Convatoria Evento evento");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.customStrings}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.CUSTOM_STRINGS,
        customStrings: snapshot.val(),
      });
    });
  };
}
//#################################################################
//#################################################################
export function getEventDataToCopy(eventoIndex, currentEvent) {
  console.log("getEventDataToCopy", eventoIndex, currentEvent);
  const refModalidadesInscripciones = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.ModalidadesInscripciones}`
  );
  const refInscripcionesConfiguracion = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.InscripcionesConfiguracion}`
  );
  const refWeb = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.web}`);
  let data = {};
  return (dispatch) => {
    return refModalidadesInscripciones
      .once("value")
      .then((snapshot) => {
        let modalidadesInscripcion = snapshot.val();
        for (var m in modalidadesInscripcion) {
          modalidadesInscripcion[m].configModalidad.folios.inscritos = 0;
          for (var g in modalidadesInscripcion[m].ramaCat) {
            for (var c in modalidadesInscripcion[m].ramaCat[g].categorias) {
              delete modalidadesInscripcion[m].ramaCat[g].categorias[c]
                .modGenCatCrono;
            }
          }
        }
        data.modalidadesInscripcion = modalidadesInscripcion;

        // dispatch(
        //   updateEventObject(
        //     currentEvent,
        //     "modalidadesInscripcion/",
        //     modalidadesInscripcion
        //   )
        // );
        return refInscripcionesConfiguracion.once("value");
      })
      .then((snapshot) => {
        data.inscripcionesConfiguracion = snapshot.val();
        // dispatch(
        //   updateEventObject(
        //     currentEvent,
        //     "inscripcionesConfiguracion/",
        //     snapshot.val()
        //   )
        // );
        return refWeb.once("value");
      })
      .then((snapshot) => {
        let web = snapshot.val();
        for (var i in web.views) {
          if (web.views[i].component === "eventRegistry") {
            web.views[i].componentConfig.eventIdDashport = currentEvent;
          }
        }
        data.web = web;

        // dispatch(updateEventObject(currentEvent, "web/", web));
        dispatch({
          type: types.EVENT_DATA_TO_COPY,
          eventDataToCopy: data,
        });
      });
  };
}
// export function eventCreateSubEventsRegistry(eventoIndex) {
//   console.log("Convatoria Evento evento");
//   var ref = fb.db.ref(
//     `${fb.EventosCompletos}/${eventoIndex}/${fb.Modalidades}`
//   );
//   return (dispatch) => {
//     ref.once("value", (snapshot) => {
//       console.log(snapshot.val())
//       if (snapshot.exists()) {
//         console.log(snapshot.val())

//         return fb.db
//       .ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.ModalidadesInscripciones}/`)
//       .set(snapshot.val())
//       .then(function() {
//         console.log("Datos Guardados");
//       })
//       .catch(function(error) {
//         console.log("Error" + error);
//       });
//        } else {
//         console.log("no existe")
//       }
//     });
//   };
// }
// Firebase Realtime Database prohíbe ". # $ / [ ]" dentro de las LLAVES de un
// objeto que se guarda con .set()/.update() (sí se permiten en rutas, pero no
// como parte de una key literal). Varios "data" que llegan aquí traen como key
// el fieldName completo (ej. "configModalidad/folios/desde"), lo cual hace que
// el .set() de abajo falle silenciosamente (el .catch no hacía nada con el
// error) y el cambio nunca quedaba logueado. Se sanitizan las keys antes de
// guardar, sin perder la ruta completa, que ya viaja aparte en "route".
function sanitizeKeysForFirebase(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return value;
  }
  const sanitized = {};
  Object.keys(value).forEach((key) => {
    const safeKey = key.replace(/[.#$/[\]]/g, "_");
    sanitized[safeKey] = sanitizeKeysForFirebase(value[key]);
  });
  return sanitized;
}

export function createEventLog(eventoIndex, data, route) {
  console.log("Guardar datos");

  if (eventoIndex) {
    // referencia a la base de datos
    const date = new Date().getTime();
    const userID = store.getState().atlete.userID;

    const finalRoute = `${fb.EventosCompletos}/${eventoIndex}/logs/${date}/`;

    return (dispatch) => {
      return fb.db
        .ref(finalRoute)
        .set({
          data: sanitizeKeysForFirebase(data),
          route: route || "NA",
          date: date,
          userIdCreate: userID || "NA",
        })
        .then(function () {
          //console.log("Datos Guardados");
        })
        .catch(function (error) {
          console.log("Error guardando log:", error);
        });
    };
  }
}
//#################################################################
export function getEventLogs(eventoIndex) {
  var ref = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/logs/`);
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      const logs = snapshot.val();
      const eventLogs = {};
      if (logs) {
        Object.keys(logs).forEach((key) => {
          const route = logs[key] && logs[key].route;
          // Los cambios sobre "deposits" son información financiera sensible
          // y no deben quedar expuestos en la vista de logs. Se descartan
          // aquí, antes de que entren al store, para que ni siquiera queden
          // disponibles en el estado de Redux del cliente.
          const esDeposits =
            typeof route === "string" &&
            route.toLowerCase().indexOf("deposits") >= 0;
          if (!esDeposits) {
            eventLogs[key] = logs[key];
          }
        });
      }
      dispatch({
        type: types.EVENT_LOGS,
        eventLogs: eventLogs,
      });
    });
  };
}
//#################################################################
export function getEventOrganizers(eventoIndex) {
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/oganizadoresEvento/`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.EVENT_ORGANIZERS,
        eventOrganizers: snapshot.val(),
      });
    });
  };
}
//#################################################################
export function getCustomViews(eventoIndex) {
  console.log("Get cutom views");
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.CustomViews}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.CUSTOM_VIEWS,
        customViews: snapshot.val(),
      });
    });
  };
}
//#################################################################
export function getTrakingLinks(eventoIndex) {
  console.log("tracking links" + eventoIndex);
  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.trackingLinks}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.TRACKING_LINKS,
        trackingLinks: { [eventoIndex]: snapshot.val() },
      });
    });
  };
}

//#################################################################

export function getCheckChip(eventoIndex) {
  console.log("check chip");
  var ref = fb.db.ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.checkChip}/`);
  return (dispatch) => {
    ref.limitToLast(30).on("child_added", (snapshot) => {
      console.log(snapshot.val());
      console.log("child added");
      dispatch({
        type: types.EVENT_CHECKCHIP,
        checkChip: snapshot.val(),
        checkChipKey: snapshot.key,
      });
    });
  };
}
//#################################################################
export function getReadersList(eventId) {
  console.log("Resultados evento");
  var ref = fb.db.ref(`${fb.Readers}`);
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      var readersList = Object.values(snapshot.val());

      dispatch({
        type: types.READERS_LIST,
        readersList: readersList.filter(
          (a) => a.readerConfig.eventId === eventId
        ),
      });
    });
  };
}
//#################################################################

export function updateReaderAttribute(readerId, data) {
  console.log("Guardar datos de evento");

  if (readerId) {
    // referencia a la base de datos
    var updates = {};

    updates[
      `${fb.Readers}/${readerId}/${fb.ReaderConfig}/${Object.keys(data)[0]}/`
    ] = Object.values(data)[0];

    console.log(data);
    console.log(readerId);
    console.log("dataTIMING", updates);

    return (dispatch) => {
      return fb.db
        .ref()
        .update(updates)
        .then(function () {
          console.log("Datos Guardados");
        })
        .catch(function (error) {
          console.log("Error" + error);
        });
    };
  }
}
//#################################################################

// Avisa a todos los lectores vinculados al evento (readerConfig.eventId
// coincide, estén o no en línea ahora mismo) que algo que ellos consultan
// localmente cambió (ej. el archivo de chips) — cada lector escucha su
// propio readerConfig/change y, al verlo incrementarse, sabe que debe
// volver a sincronizar. Un solo multi-path .update() para todos los
// lectores en vez de una escritura por lector.
export function incrementarCambioLectoresDelEvento(readersList) {
  return (dispatch) => {
    if (!readersList || readersList.length === 0) return Promise.resolve();

    var updates = {};
    readersList.forEach((reader) => {
      var readerId = reader && reader.readerConfig && reader.readerConfig.readerId;
      if (!readerId) return;
      var cambioActual = Number(reader.readerConfig.change) || 0;
      updates[
        `${fb.Readers}/${readerId}/${fb.ReaderConfig}/change/`
      ] = cambioActual + 1;
    });

    if (Object.keys(updates).length === 0) return Promise.resolve();

    return fb.db
      .ref()
      .update(updates)
      .then(function () {
        console.log("Cambio notificado a lectores");
      })
      .catch(function (error) {
        console.log("Error notificando cambio a lectores: " + error);
      });
  };
}
